import { render, staticRenderFns } from "./Pdfs.vue?vue&type=template&id=4507f1ec&"
import script from "./Pdfs.vue?vue&type=script&lang=js&"
export * from "./Pdfs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports